import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
//import axios from './plugins/axios'

//Plugins
import './plugins'
// Components
import './components'


import VueSession from 'vue-session'
import router from '@/router'
import store from '@/store'
import { API_MIXINS } from '@/mixins/api_mixins.js'
Vue.use(require('vue-moment'))
Vue.use(VueSession)
Vue.mixin(API_MIXINS)
Vue.config.productionTip = false
window.console = console
console.log = function () {}
new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
